module.exports = "pegasus/assets/themelp1/health/103.png";